import ResumeContainer from "../components/Resume/ResumeContainer";

export default function Resume() {
  return (
    <ResumeContainer />
  );
}
